import type { TDescription } from "@/models/common.model"
/**
 * This parser is used to parse the description field of the event to TDescription, even when its a record of TDescription.
 * @param description - The description to map.
 * @returns The mapped description.
 */
export function languageParser(description: TDescription | Record<string, TDescription> | undefined, locale?: string): TDescription {
  const minLocale = locale?.toLowerCase()
  if (!description) {
    return {
      long: "",
      short: "",
    }
  }
  if (typeof description === "object") {
    // Handle case where description is a record with language codes as keys
    if (description.long === undefined && description.short === undefined) {
      const values = Object.values(description)
      if (values.length === 0) {
        return {
          long: "",
          short: "",
        }
      }
      if (minLocale && (description as Record<string, TDescription>)[minLocale]) {
        const localeDesc = (description as Record<string, TDescription>)[minLocale]
        return {
          long: localeDesc?.long ?? "",
          short: localeDesc?.short ?? "",
        }
      }

      // If minLocale exists but not in the record, use 'eng' if available
      if (minLocale && (description as Record<string, TDescription>).eng) {
        const engLanguage = (description as Record<string, TDescription>).eng as TDescription
        return {
          long: engLanguage.long,
          short: engLanguage.short,
        }
      }

      // if minLocale does not exist, use the eng key as default if it exists
      if (!minLocale && (description as Record<string, TDescription>).eng) {
        const engLanguage = (description as Record<string, TDescription>).eng as TDescription
        return {
          long: engLanguage.long,
          short: engLanguage.short,
        }
      }

      const firstLanguage = values[0] as TDescription
      return {
        long: firstLanguage.long,
        short: firstLanguage.short,
      }
    }
    // Handle case where description is already a TDescription
    return {
      long: description.long as string,
      short: description.short as string,
    }
  }
  return {
    long: description,
    short: description,
  }
}
